import { Button, MenuItem, Stack } from '@mui/material';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { PURCHASE_STATUS_PAID_ID, PURCHASE_STATUSES, PurchaseDto } from '@sr/dto';
import { FormData, formTools } from './purchase.form';
import FilePickerField from 'shared/ui/formik-fields/file-picker';

type Props = {
  purchase: PurchaseDto;
  onSubmit: (formData: FormData) => Promise<void>;
};

export const PurchaseForm = ({ purchase, onSubmit }: Props) => {
  const initial = formTools.fromDto(purchase);
  return (
    <Formik initialValues={initial} enableReinitialize onSubmit={onSubmit} validate={formTools.validate}>
      {({ submitForm }: any) => (
        <Form>
          <Stack direction="column" spacing={2}>
            <Field label="Статус" component={TextField} select name="status">
              {PURCHASE_STATUSES.map((status) => (
                <MenuItem key={status.id} value={status.id} disabled={initial.status === PURCHASE_STATUS_PAID_ID}>
                  {status.label}
                </MenuItem>
              ))}
            </Field>
            <Field name="invoiceScan" label="Счет на оплату" component={FilePickerField} multiple fileCategory={'purchase-invoice-scan'}/>
            <Field name="bankDetailsScan" label="Скан реквизитов" component={FilePickerField} multiple fileCategory={'purchase-bank-detail'}/>

            <Field name="wccScan" label="Скан акта поставщика" component={FilePickerField} multiple fileCategory={'purchase-wcc-scan'}/>

            <Field name="promoScan" label="Подписанный макет" component={FilePickerField} multiple fileCategory={'purchase-promo-scan'}/>
            <Field name="photoProof" label="Фотоотчет" component={FilePickerField} multiple fileCategory={'purchase-photo-proof'}/>
            <Button onClick={submitForm} variant="contained" sx={{ ml: 'auto', mr: 1 }}>
              Сохранить
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};
